app.service('productLimitedService',function(console, modal, loading, validate) {
	var $modal;
	var service, product;

	function load(serviceId, productId){
		service = serviceId;
		product = productId;

		$.ajax({
			url: '/limited-service-availability.ltr',
			success: function(data){
				loadSuccess(data);
			}
		});
	}

	function loadSuccess(data){
		var modalId = 'modal-limited-service';

		modal.generate({
			id: modalId,
			content: data,
			cssClass: 'limited-service-modal',
			callbackOpen: function(){
				$modal = $('#'+modalId);
				loadSuccessCallback();
			}
		});
	}

	function loadSuccessCallback(){
		autocompleteDelivery("limited-service-zip-code", "limited-service-city-name");
		$('#limited-service-zip-code', $modal).mask2('99-999');
		$('#limited-service-zip-code', $modal).keyfilter(/[\d\-]/);
		validate.task('limitedService', function(form) {
			send(form);
		});
	}

	function send(form) {
		$(form).ajaxSubmit({
			url: '/check-limited-service-availability.ltr',
			data:{
				serviceId: service
			},
			success:function(data) {
				sendSuccess(data.responseMsg);
			}
		});
	}

	function sendSuccess(data) {
		$("#response-message",$modal).html(data);
	}

	return {
		load:load
	};
});
